import { RouterPath } from "./router-path";

export class MenuLinkRegex {
  public static Routes =  RouterPath.Routes + '**';
  public static Allocation =  RouterPath.Allocation + '**';
  public static Customers =  RouterPath.Customers + '**';
  public static Invoices =  RouterPath.Invoices + '**';
  public static Vehicles =  RouterPath.Vehicles + '**';
  public static Products =  RouterPath.Products + '**';
  public static Users =  RouterPath.Users + '**';
  public static Tenants =  RouterPath.Tenants + '**';
  public static Messages =  RouterPath.Messages + '**';
}
